import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import { PosBackground } from "../../images";

type Props = {};

const Dashboard = (props: Props) => {
  const { data: profileData, isPending: profileDataLoading } = useGetHook({
    queryKey: ["profile"],
    url: `${APIS.PROFILE}`,
    params: {},
  });
  return (
    <div className="flex justify-center w-full overflow-hidden">
      <img src={PosBackground} alt="" className="w-fit h-[91vh]" />
    </div>
  );
};

export default Dashboard;
